import { Validator } from 'fluentvalidation-ts';
import { beValidSequence } from '../../../validators/stringValidators';
import { HandoverPackSectionResponse } from '../documentResponse';

export type HandoverPackSectionFormModel = {
  sectionName: string;
  sectionSequence: string;
};

export const initialHandoverPackSectionFormModel: HandoverPackSectionFormModel = {
  sectionName: '',
  sectionSequence: '',
};

export const mapHandoverPackSectionToFormModel = (
  section: HandoverPackSectionResponse,
): HandoverPackSectionFormModel => ({
  sectionName: section.sectionName,
  sectionSequence: section.sectionSequence,
});

class HandoverPackSectionFormModelValidator extends Validator<HandoverPackSectionFormModel> {
  constructor() {
    super();

    this.ruleFor('sectionName')
      .notEmpty()
      .withMessage('Section name is required')
      .maxLength(200)
      .withMessage('Please enter no more than 200 characters');

    this.ruleFor('sectionSequence').must(beValidSequence);
  }
}

export const handoverPackSectionFormModelValidator = new HandoverPackSectionFormModelValidator();
